import React from 'react';
import { ErrorMessage } from 'design-system/src/components/ErrorMessage/ErrorMessage';
import { PROVIDER_SUPPORT_CONTACT_INFO } from '../../constants';

export interface GenericContactSupportErrorProps {
  /**
   * ID for connecting to input fields with aria-describedby
   */
  id?: string;
}

/**
 * Generic error message prompting users to contact support via email.
 */
export const GenericContactSupportError: React.FC<GenericContactSupportErrorProps> = ({ id }) => {
  return (
    <ErrorMessage id={id}>
      An error occurred. Please reach out to our team at{' '}
      <a
        href={`mailto:${PROVIDER_SUPPORT_CONTACT_INFO.email}`}
        className="whitespace-nowrap text-red-400 hover:text-red-500"
      >
        {PROVIDER_SUPPORT_CONTACT_INFO.email}
      </a>
      .
    </ErrorMessage>
  );
};
